import * as React from 'react';
import RcDropdown from 'rc-dropdown';
import classNames from 'classnames';
import RightOutlined from '@ant-design/icons/RightOutlined';
import DropdownButton from './dropdown-button';
import { ConfigContext } from '../config-provider';
import warning from '../_util/warning';
import { tuple } from '../_util/type';
import { cloneElement } from '../_util/reactNode';
import getPlacements from '../_util/placements';
import OverrideContext from '../menu/OverrideContext';
const Placements = tuple('topLeft', 'topCenter', 'topRight', 'bottomLeft', 'bottomCenter', 'bottomRight', 'top', 'bottom');
const Dropdown = props => {
    const { getPopupContainer: getContextPopupContainer, getPrefixCls, direction, } = React.useContext(ConfigContext);
    const getTransitionName = () => {
        const rootPrefixCls = getPrefixCls();
        const { placement = '', transitionName } = props;
        if (transitionName !== undefined) {
            return transitionName;
        }
        if (placement.indexOf('top') >= 0) {
            return `${rootPrefixCls}-slide-down`;
        }
        return `${rootPrefixCls}-slide-up`;
    };
    const getPlacement = () => {
        const { placement } = props;
        if (!placement) {
            return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
        }
        if (placement.includes('Center')) {
            const newPlacement = placement.slice(0, placement.indexOf('Center'));
            warning(!placement.includes('Center'), 'Dropdown', `You are using '${placement}' placement in Dropdown, which is deprecated. Try to use '${newPlacement}' instead.`);
            return newPlacement;
        }
        return placement;
    };
    const { arrow, prefixCls: customizePrefixCls, children, trigger, disabled, getPopupContainer, overlayClassName, } = props;
    const prefixCls = getPrefixCls('dropdown', customizePrefixCls);
    const child = React.Children.only(children);
    const dropdownTrigger = cloneElement(child, {
        className: classNames(`${prefixCls}-trigger`, {
            [`${prefixCls}-rtl`]: direction === 'rtl',
        }, child.props.className),
        disabled,
    });
    const overlayClassNameCustomized = classNames(overlayClassName, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
    });
    const triggerActions = disabled ? [] : trigger;
    let alignPoint;
    if (triggerActions && triggerActions.indexOf('contextMenu') !== -1) {
        alignPoint = true;
    }
    const builtinPlacements = getPlacements({
        arrowPointAtCenter: typeof arrow === 'object' && arrow.pointAtCenter,
        autoAdjustOverflow: true,
    });
    const overlayContext = React.useMemo(() => ({
        prefixCls: `${prefixCls}-menu`,
        expandIcon: (<span className={`${prefixCls}-menu-submenu-arrow`}>
          <RightOutlined className={`${prefixCls}-menu-submenu-arrow-icon`}/>
        </span>),
        mode: 'vertical',
        selectable: false,
        validator: ({ mode }) => {
            // Warning if use other mode
            warning(!mode || mode === 'vertical', 'Dropdown', `mode="${mode}" is not supported for Dropdown's Menu.`);
        },
    }), [prefixCls]);
    const renderOverlay = () => {
        // rc-dropdown already can process the function of overlay, but we have check logic here.
        // So we need render the element to check and pass back to rc-dropdown.
        const { overlay } = props;
        let overlayNode;
        if (typeof overlay === 'function') {
            overlayNode = overlay();
        }
        else {
            overlayNode = overlay;
        }
        overlayNode = React.Children.only(typeof overlayNode === 'string' ? <span>{overlayNode}</span> : overlayNode);
        return (<OverrideContext.Provider value={overlayContext}>{overlayNode}</OverrideContext.Provider>);
    };
    return (<RcDropdown alignPoint={alignPoint} {...props} builtinPlacements={builtinPlacements} arrow={!!arrow} overlayClassName={overlayClassNameCustomized} prefixCls={prefixCls} getPopupContainer={getPopupContainer || getContextPopupContainer} transitionName={getTransitionName()} trigger={triggerActions} overlay={renderOverlay} placement={getPlacement()}>
      {dropdownTrigger}
    </RcDropdown>);
};
Dropdown.Button = DropdownButton;
Dropdown.defaultProps = {
    mouseEnterDelay: 0.15,
    mouseLeaveDelay: 0.1,
};
export default Dropdown;
